/**
 * Mapeo centralizado de colores para estados de órdenes y productos
 *
 * DECISION (unificación jul 2026): ordenes se alinea al sistema de badges
 * corporativo UNIFICADO (pastel + texto oscuro accesible + borde), usando la
 * paleta compartida src/components/ui/badgeColors.js. Se conservan los TONOS
 * históricos de ordenes (azul=sin preparar, rojo=en preparación, verde=preparado,
 * ámbar=en revisión) porque el sistema corporativo se derivó justamente de ellos.
 */

import { BADGE_COLORS, getBadgeStyles } from "../../../components/ui/badgeColors";

// Estados de PEDIDOS/ÓRDENES: 1=Sin preparar, 2=En preparación, 3=Preparado, 4=En revisión
const ORDER_STATE_BADGE_COLORS = {
  "1": BADGE_COLORS.BLUE, // Sin preparar
  "2": BADGE_COLORS.RED, // En preparación
  "3": BADGE_COLORS.GREEN, // Preparado
  "4": BADGE_COLORS.AMBER, // En revisión
  "0": BADGE_COLORS.GRAY, // Indefinido
};

// Estados de PRODUCTOS: 0=Pendiente, 1=Completado, 2=Falta
const PRODUCT_STATE_BADGE_COLORS = {
  "0": BADGE_COLORS.AMBER, // Pendiente
  "1": BADGE_COLORS.GREEN, // Completado
  "2": BADGE_COLORS.RED, // Falta
};

/**
 * Obtiene el objeto de color corporativo para un estado de orden/pedido
 * @param {string|number} state - Estado de la orden (1, 2, 3, 4)
 * @returns {Object} Objeto de color de BADGE_COLORS
 */
export const getOrderStateBadgeColor = (state) => {
  return ORDER_STATE_BADGE_COLORS[String(state)] || BADGE_COLORS.GRAY;
};

/**
 * Obtiene el objeto de color corporativo para un estado de producto
 * @param {string|number} state - Estado del producto (0, 1, 2)
 * @returns {Object} Objeto de color de BADGE_COLORS
 */
export const getProductStateBadgeColor = (state) => {
  return PRODUCT_STATE_BADGE_COLORS[String(state)] || BADGE_COLORS.GRAY;
};

/**
 * Estilos sx (pastel corporativo) para un Chip con estado de orden/pedido
 * @param {string|number} state - Estado de la orden
 * @param {Object} options - Opciones (height, fontSize, withBorder)
 * @returns {Object} Objeto de estilos para sx prop
 */
export const getOrderStateBadgeStyles = (state, options = {}) => {
  return getBadgeStyles(getOrderStateBadgeColor(state), options);
};

/**
 * Estilos sx (pastel corporativo) para un Chip con estado de producto
 * @param {string|number} state - Estado del producto
 * @param {Object} options - Opciones (height, fontSize, withBorder)
 * @returns {Object} Objeto de estilos para sx prop
 */
export const getProductStateBadgeStyles = (state, options = {}) => {
  return getBadgeStyles(getProductStateBadgeColor(state), options);
};

/**
 * Color hexadecimal del tono (borde) de un estado de orden.
 * Útil para acentos no-badge (bordes de card, indicadores).
 * @param {string|number} state - Estado de la orden
 * @returns {string} Color hexadecimal
 */
export const getOrderStateColor = (state) => getOrderStateBadgeColor(state).border;

/**
 * Color hexadecimal del tono (borde) de un estado de producto.
 * @param {string|number} state - Estado del producto
 * @returns {string} Color hexadecimal
 */
export const getProductStateColor = (state) => getProductStateBadgeColor(state).border;
